import React, { useCallback } from 'react'

import { useDispatch } from 'react-redux'
import { login, updateSession } from 'session'
import { ValidationError } from 'epc-schema'
import { handleNetworkError } from 'utils'

import { LoginForm, LoginFormValues } from './LoginForm'

export const LoginFormConnected: React.FC = () => {
  const dispatch = useDispatch()

  const handleFromSubmission = useCallback(
    async ({ email, password }: LoginFormValues) => {
      return await handleNetworkError<ValidationError>(async () => {
        const { accessToken, refreshToken, errors } = await login(
          process.env.REACT_APP_EPC_API_URL ??
            process.env.REACT_APP_API_URL ??
            '',
          {
            email: email as string,
            password: password as string,
          }
        )

        if (accessToken && refreshToken) {
          dispatch(updateSession({ accessToken, refreshToken }))
        }

        return errors ?? []
      }, process.env.REACT_APP_EPC_API_URL ?? '')
    },
    [dispatch]
  )

  return <LoginForm onSubmit={handleFromSubmission} />
}
